export default __webpack_public_path__ + "img/component-menu.57945b66.png";